import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiResponse, LangCode, SubmitResponse } from '@sgm-frontend/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class HttpService<TInput, TResponse> {

  protected readonly apiUrl = `${this.url}/api/${this.version}/${this.endpoint}`;
  protected readonly apiUrlNoEnd = `${this.url}/api/${this.version}`;

  constructor(
    public httpClient: HttpClient,
    @Inject(String) private url: string,
    @Inject(String) private version: string,
    @Inject(String) private endpoint: string
  ) {

   }

  //#region GET
  protected _getAllPaged(action = '', page = 1): Observable<TResponse[]> {
    const url = action === '' ? `${this.apiUrl}?page=${page}` : `${this.apiUrl}/${action}?page=${page}`;
    return this.httpClient.get<TResponse[]>(url);
  }

  protected _getById(entityId: number | string, action = '',role?:string): Observable<TResponse> {
    let url = action === '' ? `${this.apiUrl}/${entityId}` : `${this.apiUrl}/${action}/${entityId}`;
    if(role){
     url += `/${role}`;
    }
    return this.httpClient.get<TResponse>(url);
  }

  protected getAll(action = ''): Observable<TResponse | TResponse[]> {
    const url = action === '' ? `${this.apiUrl}` : `${this.apiUrl}/${action}`;
    return this.httpClient.get<ApiResponse<TResponse | TResponse[]>>(url).pipe(map((x) => x.data));
  }

 protected getAllPaged(action = '', page = 1, suffix = '', limit?: number ): Observable<TResponse> {
    let url = action === '' ? `${this.apiUrl}?page=${page}` : `${this.apiUrl}/${action}?page=${page}`;
    if (suffix) {
      url += `&${suffix}`; // Added suffix so that debugging in Network Tab is easier
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    return this.httpClient.get<ApiResponse<TResponse>>(url).pipe(map((x) => x.data));
  }
  protected getAllPagedDeal(action = '', page = 1, suffix = '', limit?: number ): Observable<TResponse> {
    let url = action === '' ? `${this.apiUrl}?page=${page}` : `${this.apiUrl}/${action}&page=${page}`;
    if (suffix) {
      url += `&${suffix}`; // Added suffix so that debugging in Network Tab is easier
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    return this.httpClient.get<ApiResponse<TResponse>>(url).pipe(map((x) => x.data));
  }
  protected getAllNPaged(
  action = '',
  page = 1,
  suffix = '',
  limit?: number,
  lastDays?: number
): Observable<TResponse> {
  let url = action === '' ? `${this.apiUrl}?page=${page}` : `${this.apiUrl}/${action}?page=${page}`;
  
  if (suffix) {
    url += `&${suffix}`;
  }
  if (limit) {
    url += `&limit=${limit}`;
  }
  if (lastDays) {
    url += `&last_days=${lastDays}`;
  }

  return this.httpClient.get<ApiResponse<TResponse>>(url).pipe(map((x) => x.data));
}

  protected getAllByLangCode(langCode: LangCode, page = 1): Observable<TResponse> {
    const url = `${this.apiUrl}/lang/${langCode}?page=${page}`;
    return this.httpClient.get<ApiResponse<TResponse>>(url).pipe(map((x) => x.data));
  }

  protected getAllById(action = '', entityId: number | string): Observable<TResponse[]> {
    const url = action === '' ? `${this.apiUrl}/${entityId}` : `${this.apiUrl}/${action}/${entityId}`;
    return this.httpClient.get<ApiResponse<TResponse[]>>(url).pipe(map((x) => x.data));
  }

   protected getById(entityId: number | string, action = '' , role?:string,values?:string): Observable<TResponse> {
    let url = action === '' ? `${this.apiUrl}/${entityId}` : `${this.apiUrl}/${action}/${entityId}`;
    if(role){
     url += `/${role}`;
    }
    if(values){
      url += `/${values}`;
    }
    return this.httpClient.get<ApiResponse<TResponse>>(url).pipe(map((x) => x.data));
  }

  protected getBy(action = '', params?: any): Observable<TResponse> {
    const url = action === '' ? this.apiUrl : `${this.apiUrl}/${action}`;
    return this.httpClient.get<ApiResponse<TResponse>>(url, { params }).pipe(map((x) => x.data));
  }

  protected searchAllPaged(entity: TInput): Observable<TResponse> {
    const url = `${this.apiUrl}/search/`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }


  protected filterAllPaged(entity: TInput): Observable<TResponse> {
    const url = `${this.apiUrl}/filter/`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }
  protected filterAllPagedAdmin(entity: TInput): Observable<TResponse> {
    const url = `${this.apiUrl}/filter`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }
   protected filterAllActionPagedAdmin(entity: TInput, action?: string): Observable<TResponse> {
    const url =  action === '' ?`${this.apiUrl}/filter` : `${this.apiUrl}/${action}/filter`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }

  protected filterAllActionPaged(entity: TInput, action?: string): Observable<TResponse> {
    const url =  action === '' ?`${this.apiUrl}/filter` : `${this.apiUrl}/${action}/filter`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }

  protected filterAllRports(entity: TInput, action: string): Observable<TResponse> {
    const url =  action === '' ?`${this.apiUrl}` : `${this.apiUrl}/${action}`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }
   protected filterReturnActionPaged(entity: TInput, action: string): Observable<TResponse> {
    const url = action 
  ? `${this.apiUrl}/filter/${action}` 
  : `${this.apiUrl}/filter`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }
   protected filterSearchReturnActionPaged(entity: TInput, action?: string): Observable<TResponse> {
    const url = action 
  ? `${this.apiUrl}/${action}` 
  : `${this.apiUrl}/filter`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }

  //#endregion
  protected createHeaderToken<TResponse>(
    entity: TInput,
    action = '',
    accessToken?: string // <--- New optional parameter for the token
  ): Observable<HttpResponse<TResponse>> { // Ensure it returns HttpResponse
    const url = action === '' ? this.apiUrl : `${this.apiUrl}/${action}`;

    let headers = new HttpHeaders();
    if (accessToken) {
      // Set the Authorization header with 'Bearer' prefix
      headers = headers.set('Authorization', `Bearer ${accessToken}`); // For debugging
    }

    return this.httpClient.post<TResponse>(
      url,
      entity,
      {
        headers: headers, // <--- Pass the created headers object
        observe: 'response' // <--- Crucial to get the full HttpResponse
      }
    );
  }
  protected create(entity?: TInput, action = ''): Observable<SubmitResponse> {
    const url = action === '' ? this.apiUrl : `${this.apiUrl}/${action}`;
    return this.httpClient.post<SubmitResponse>(url, entity);
  }
  protected createHttpRes<TOutput>(entity: TInput, action = ''): Observable<HttpResponse<TOutput>> {
    const url = action === '' ? this.apiUrl : `${this.apiUrl}/${action}`;
    return this.httpClient.post<TOutput>(url, entity, { observe: 'response' }); // <--- KEY CHANGE
  }
    protected createAdminHttpRes<TOutput>(entity: TInput, action = ''): Observable<HttpResponse<TOutput>> {
    const url = action === '' ? this.apiUrlNoEnd : `${this.apiUrlNoEnd}/${action}`;
    return this.httpClient.post<TOutput>(url, entity, { observe: 'response' }); // <--- KEY CHANGE
  }


  protected update(entity: TInput, action = '', entityAction?: string | number): Observable<SubmitResponse> {
    let url = action === '' ? this.apiUrl : `${this.apiUrl}/${action}`;
    if (entityAction) {
      url += `/${entityAction}`;
    }
    return this.httpClient.put<SubmitResponse>(url, entity);
  }

  protected patch(entityId?: number | string, data?: any, action = '', entityAction?: string | number): Observable<SubmitResponse> {
    let url = action === '' ? `${this.apiUrl}/${entityId}` : `${this.apiUrl}/${action}/${entityId}`;
    if (entityAction) {
      url += `/${entityAction}`;
    }
    return this.httpClient.patch<SubmitResponse>(url, data);
  }
   protected patchWithID( data: any, action?:string): Observable<SubmitResponse> {
    let url = `${this.apiUrl}`;
    if (action) {
      url += `/${action}`;
    }
    return this.httpClient.patch<SubmitResponse>(url, data);
  }
// https://api.stargallery.org/api/v1/product/123/variant/456
  protected delete(entityId: any | string, action = '' , role?:string): Observable<ApiResponse<TResponse>> {
    let url = action === '' ? `${this.apiUrl}/${entityId}` : `${this.apiUrl}/${action}/${entityId}`;
    if(role){
      url += `/${role}`; 
    }

    return this.httpClient.delete<SubmitResponse>(url);
  }
    protected deleteDirectUrl(entityId: any | string, action = '' , role?:string): Observable<ApiResponse<TResponse>> {
    let url = action === '' ? `${this.apiUrlNoEnd}/${entityId}` : `${this.apiUrlNoEnd}/${action}/${entityId}`;
    if(role){
      url += `/${role}`; 
    }

    return this.httpClient.delete<SubmitResponse>(url);
  }

  //
  protected createN(entity?: TInput, action = ''): Observable<SubmitResponse> {
    const url = action === '' ? this.apiUrlNoEnd :(this.endpoint==='' ? `${this.apiUrlNoEnd}/${action}`: `${this.apiUrlNoEnd}/${action}`);
    return this.httpClient.post<SubmitResponse>(url, entity);
  }
   protected createHttpResN<TOutput>(entity: TInput, action = ''): Observable<HttpResponse<TOutput>> {
    const url = action === '' ? this.apiUrlNoEnd :`${this.apiUrlNoEnd}/${action}`;
    return this.httpClient.post<TOutput>(url, entity, { observe: 'response' }); // <--- KEY CHANGE
  }
  protected getAllGeneral(action = ''): Observable<TResponse | TResponse[]> {
    const url = action === '' ? `${this.apiUrlNoEnd}` : `${this.apiUrlNoEnd}/${action}`;
    return this.httpClient.get<ApiResponse<TResponse | TResponse[]>>(url).pipe(map((x) => x.data));
  }

  protected getPagedGeneral(action = '', page = 1, limit = 10): Observable<TResponse> {
    let url = action === '' ? `${this.apiUrlNoEnd}?page=${page}` : `${this.apiUrlNoEnd}/${action}?page=${page}`;
    if (limit) {
      url += `&limit=${limit}`;
    }
    return this.httpClient.get<ApiResponse<TResponse>>(url).pipe(map((x) => x.data));
  }

  protected searchAllPagedWithQuery(query: string, withQuery = true): Observable<TResponse> {
    const url = withQuery ? `${this.apiUrl}/search?q=${query}` : `${this.apiUrl}/search=${query}`;
    return this.httpClient.get<ApiResponse<TResponse>>(url).pipe(map((x) => x.data));
  }
  

  protected deleteByIds(action = '',Id: number | string | Array<number | string>): Observable<SubmitResponse> {
    let url: string;

    if (Array.isArray(Id)) {
      const ids = Id.join(',');
      url = action === ''
        ? `${this.apiUrlNoEnd}?ids=${ids}`
        : `${this.apiUrlNoEnd}/${action}?ids=${ids}`;
    } else {
      url = action === ''
        ? `${this.apiUrlNoEnd}/${Id}`
        : `${this.apiUrlNoEnd}/${action}/?ids=${Id}`;
    }

    return this.httpClient.delete<SubmitResponse>(url);
  }

    protected autoCompleteSearch(
    entity: any,
    action = ''): Observable<TResponse[]> {
    const url = action === '' ? `${this.apiUrl}/autocomplete` : `${this.apiUrl}/${action}/autocomplete`;
    return this.httpClient.post<ApiResponse<TResponse[]>>(url, entity).pipe(map((x) => x.data));
  }
  protected getHandleFee(action = '', cartTotal = 1, method="tabby"): Observable<TResponse> {
    let url = action === '' ? `${this.apiUrl}?cart_total=${cartTotal}&payment_method=${method}` : `${this.apiUrl}/${action}?cart_total=${cartTotal}&payment_method=${method}`;
    
    return this.httpClient.get<ApiResponse<TResponse>>(url).pipe(map((x) => x.data));
  }
    protected createQuatation(entity?: TInput, action = ''): Observable<SubmitResponse> {
    const url = action === '' ? this.apiUrlNoEnd : `${this.apiUrlNoEnd}/${action}`;
    return this.httpClient.post<SubmitResponse>(url, entity);
  }

  protected getSearchPages(entity?: TInput): Observable<TResponse> {
    const url = `${this.apiUrl}/admin/items`;
    return this.httpClient.post<ApiResponse<TResponse>>(url, entity).pipe(map((x) => x.data));
  }

  protected deleteInBulk(entity?: TInput, action = ''): Observable<SubmitResponse> {
    const url = action === '' ? `${this.apiUrl}/variant/bulk-delete` : `${this.apiUrl}/${action}/bulk-delete`;
    return this.httpClient.post<SubmitResponse>(url, entity);
  }

  protected downloadInvoice(url: string, filename: string): Observable<void> {
    return this.httpClient.get(url, { responseType: 'blob' }).pipe(
      map((blob: Blob) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(link.href);
      })
    );
  }

  protected downloadFile(action: string, params?: any): Observable<Blob> {
    const url = `${this.apiUrlNoEnd}/${action}`;
    return this.httpClient.get(url, { params, responseType: 'blob' });
  }

  protected downloadFileWithParams(action: string, params?: any): Observable<Blob> {
    const url = `${this.apiUrlNoEnd}/${action}`;
    return this.httpClient.post(url, params, { responseType: 'blob' });
  }

}
